import React, { useState } from 'react';
import { useTheme } from '../../theme/ThemeContext';
import './themeSwitcher.css';

export const ThemeSwitcher: React.FC = () => {
  const { theme, setTheme, availableThemes } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const handleThemeChange = (themeName: string) => {
    setTheme(themeName);
    setIsOpen(false);
  };

  return (
    <div className="theme-switcher">
      <button
        className="theme-switcher-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Змінити тему"
        aria-expanded={isOpen}
      >
        🎨 {theme.displayName}
      </button>
      
      {isOpen && (
        <>
          <div 
            className="theme-switcher-overlay"
            onClick={() => setIsOpen(false)}
          />
          <div className="theme-switcher-menu">
            {Object.values(availableThemes).map((t) => (
              <button
                key={t.name}
                className={`theme-option ${theme.name === t.name ? 'active' : ''}`}
                onClick={() => handleThemeChange(t.name)}
                aria-label={`Обрати тему: ${t.displayName}`}
              >
                <span className="theme-option-indicator" />
                {t.displayName}
                {theme.name === t.name && <span className="check-mark">✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
